import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScannerCaseFilter, ScannerCaseOrderStatus, ScanSource } from 'models/scanner-case';

type DentistScannerCasesPageActionsProps = {
    onFilterChange: (filters: ScannerCaseFilter) => void;
    initFilters: ScannerCaseFilter;
};
const DentistScannerCasesPageActions: FC<DentistScannerCasesPageActionsProps> = ({ onFilterChange, initFilters }) => {
    const { t: translate } = useTranslation(['scan-cases', 'common']);
    const [searchTimeout, setSearchTimeout] = useState<ReturnType<typeof setTimeout>>();
    const [search, setSearch] = useState(initFilters.search || '');

    useEffect(() => {
        setSearch(initFilters.search || '');
        if (initFilters.search) {
            setSearch(initFilters.search);
        }
    }, [initFilters]);

    const emitChange = (search: string, orderStatus?: ScannerCaseOrderStatus, source?: ScanSource) => {
        const filters = {
            search,
            orderStatus,
            source,
        };
        onFilterChange(filters);
    };

    const handleTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setSearch(value);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }
        const timeout = setTimeout(() => {
            if (value.length === 0 || value.length >= 3) {
                emitChange(value);
            }
        }, 300);
        setSearchTimeout(timeout);
    };

    return (
        <Grid container>
            <Grid item md={5} sm={6} xs={12}>
                <TextField
                    fullWidth
                    onChange={handleTextChange}
                    label={translate('scan-cases:FREE_TEXT_FILTER')}
                    placeholder={translate('scan-cases:FREE_TEXT_FILTER_PLACEHOLDER')}
                    value={search}
                />
            </Grid>
        </Grid>
    );
};

export default DentistScannerCasesPageActions;
